import React from "react";
import VerifyLogin from "../auth/VerifyLogin";

export default function VerifyLoginPage() {
  return <VerifyLogin />;
}
